import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import NotificationsContainer from './NotificationsContainer'


const NotificationsRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><NotificationsContainer></NotificationsContainer></Provider>
}

NotificationsRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default NotificationsRoot
